import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _3mpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"3mp"}/>
}
